import { ACTION_TYPE } from "../action/type";
const initialState = {
  productDescriptionResponesLoading: false,
  productDescriptionResponseSuccess: [],
  productDescriptionResponseError: null,
};

const searchcategoriesinitialState = {
  searchcategoriesResponesLoading: false,
  searchcategoriesResponseSuccess: [],
  searchcategoriesResponseError: null,
};
const sizeinitialState = {
  productSizeResponesLoading: false,
  productSizeResponseSuccess: [],
  productSizeResponseError: null,
};

const cvdVariantsInitialState = {
  cvdVariantsLoading: false,
  cvdVariants: [],
  uniquePurity: [],
  uniqueMetalColor: [],
  cvdVariantsError: null,
};

const productlistinitialState = {
  productListResponesLoading: false,
  productListResponseSuccess: [],
  productListResponseError: null,
};

const productlistitemsinitialState = {
  productListitemsResponesLoading: false,
  productListitemsResponseSuccess: [],
  productMinPrice: 0,
  productMaxPrice: 200000,
  currentPriceRange: [0, 200000],
  productListitemsResponseError: null,
  currentOffset: 0,
  currentPage: 0,
  selectedFiltersNew: {
    Collection: [],
    Theme: [],
    Occasion: [],
    Style: [],
    Finish: [],
    "Product Type": [],
    "Sort By": null,
  },
};

const getSEODataInitialState = {
  getSEODataResponseLoading: false,
  getSEODataResponseSuccess: [],
  getSEODataResponseError: null,
};

export function productReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPE.GET_PRODUCT_DATA_REQUEST:
      return {
        ...state,
        productDescriptionResponesLoading: true,
        productDescriptionResponseSuccess: [],
        productDescriptionResponseError: null,
      };
    case ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_SUCCESS:
      return {
        ...state,
        productDescriptionResponesLoading: false,
        // productDescriptionResponseSuccess:
        //   action.payload.productResponseSuccess,
        productDescriptionResponseSuccess:
          action.payload.productResponseSuccess.map((item) => ({
            ...item,
            isLiked: false,
          })),
        productDescriptionResponseError: null,
      };
    case ACTION_TYPE.UPDATE_PRODUCT_DESCRIPTION_SUCCESS:
      return {
        ...state,
        productDescriptionResponseSuccess: action.payload,
      };
    case ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_FAILURE:
      return {
        ...state,
        productDescriptionResponesLoading: false,
        productDescriptionResponseSuccess: [],
        productDescriptionResponseError: action.errorMessage,
      };

    default:
      return state;
  }
}

export function productSizeReducer(state = sizeinitialState, action) {
  switch (action.type) {
    case ACTION_TYPE.GET_PRODUCT_SIZE_DATA_REQUEST:
      return {
        ...state,
        productSizeResponesLoading: true,
        productSizeResponseSuccess: [],
        productSizeResponseError: null,
      };

    case ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_SUCCESS:
      return {
        ...state,
        productSizeResponesLoading: false,
        productSizeResponseSuccess: action.payload.productSizeResponseSuccess,
        productSizeResponseError: null,
      };

    case ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_FAILURE:
      return {
        ...state,
        productSizeResponesLoading: false,
        productSizeResponseSuccess: [],
        productSizeResponseError: action.errorMessage,
      };

    default:
      return state;
  }
}

export function cvdVariantsReducer(state = cvdVariantsInitialState, action) {
  switch (action.type) {
    case ACTION_TYPE.CVD_VARIANTS_REQUEST:
      return { ...state, cvdVariantsLoading: true, cvdVariantsError: null };
    case ACTION_TYPE.CVD_VARIANTS_SUCCESS:
      return {
        ...state,
        cvdVariantsLoading: false,
        cvdVariants: action.payload.cvdVariants,
        uniquePurity: action.payload.uniquePurity,
        uniqueMetalColor: action.payload.uniqueMetalColor,
      };
    case ACTION_TYPE.CVD_VARIANTS_FAILURE:
      return { ...state, cvdVariantsLoading: false, cvdVariantsError: action.errorMessage };
    default:
      return state;
  }
}

//categories
export function SearchCategoryReducer(
  state = searchcategoriesinitialState,
  action
) {
  switch (action.type) {
    case ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_REQUEST:
      return {
        ...state,
        searchcategoriesResponesLoading: false,
        searchcategoriesResponseSuccess: [],
        searchcategoriesResponseError: null,
      };
    case ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_SUCCESS:
      return {
        ...state,
        searchcategoriesResponesLoading: false,
        searchcategoriesResponseSuccess:
          action.payload.searchcategoryResponseSuccess,
        searchcategoriesResponseError: null,
      };
    case ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_FAILURE:
      return {
        ...state,
        searchcategoriesResponesLoading: false,
        searchcategoriesResponseSuccess: [],
        searchcategoriesResponseError: action.errorMessage,
      };

    default:
      return state;
  }
}

export function productFilterListReducer(
  state = productlistinitialState,
  action
) {
  switch (action.type) {
    case ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_REQUEST:
      return {
        ...state,
        productListResponesLoading: true,
        productListResponseSuccess: [],
        productListResponseError: null,
        //productListitemsResponesLoading: true
      };
    case ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_SUCCESS:
      return {
        ...state,
        productListResponesLoading: false,
        productListResponseSuccess: action.payload.productResponseSuccess,
        productListResponseError: null,
        //productListitemsResponesLoading: false
      };
    case ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_FAILURE:
      return {
        ...state,
        productListResponesLoading: false,
        productListResponseSuccess: [],
        productListResponseError: action.errorMessage,
        //productListitemsResponesLoading: false
      };

    default:
      return state;
  }
}

export function productFilterListitemsReducer(
  state = productlistitemsinitialState,
  action
) {
  switch (action.type) {
    case ACTION_TYPE.GET_PRODUCT_LIST_DATA_REQUEST:
      return {
        ...state,
        productListitemsResponesLoading: true,
        productListitemsResponseSuccess: [],
        productListitemsResponseError: null,
        // productMaxPrice: 150000,
        // productMinPrice: 0,
      };
    case ACTION_TYPE.UPDATE_PRODUCT_LIST_ITEMS_SUCCESS:
      return {
        ...state,
        productListitemsResponseSuccess: action.payload,
      };
    // case ACTION_TYPE.UPDATE_SELECTED_FILTERS:
    //   return {
    //     ...state,
    //     selectedFiltersNew: {
    //       ...state.selectedFiltersNew,
    //       [action.payload.category]: action.payload.value,
    //     },
    //   };
    case ACTION_TYPE.UPDATE_SELECTED_FILTERS: {
  const { category, value, finalPriceRange } = action.payload;
  const updatedFilters = { ...state.selectedFiltersNew };

  // If category is valid, update it
  if (category !== null) {
    updatedFilters[category] = value;
  }

  // Only set price filter when user has selected a specific price range
  if (finalPriceRange !== null && finalPriceRange !== undefined) {
    const isFinalPriceValid =
      Array.isArray(finalPriceRange) &&
      finalPriceRange.length === 2 &&
      finalPriceRange[0] !== null &&
      finalPriceRange[1] !== null;

    if (isFinalPriceValid) {
      const isDefaultRange = (finalPriceRange[0] == "0" && finalPriceRange[1] == "200000") || 
                             (finalPriceRange[0] == 0 && finalPriceRange[1] == 200000);
      if (!isDefaultRange) {
        updatedFilters.price = {
          min_price: finalPriceRange[0],
          max_price: finalPriceRange[1],
        };
      } else {
        // Remove price filter for default range
        delete updatedFilters.price;
      }
    }
  }

  // Return updated state
  return {
    ...state,
    selectedFiltersNew: updatedFilters,
  };
}

    //RESET_SELECTED_FILTERS
    case ACTION_TYPE.RESET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFiltersNew: {
          Collection: [],
          Theme: [],
          Occasion: [],
          Style: [],
          Finish: [],
          "Product Type": [],
          "Sort By": null,
        },
        currentPriceRange: [0, 200000],
      };

    case ACTION_TYPE.GET_PRODUCT_LIST_DATA_SUCCESS:
      return {
        ...state,
        productListitemsResponesLoading: false,
        productListitemsResponseSuccess: {
          ...action.payload.productListitemResponseSuccess,
          data: {
            ...action.payload.productListitemResponseSuccess.data,
            allProductLists:
              action.payload.productListitemResponseSuccess.data.allProductLists.map(
                (item) => ({
                  ...item,
                  isLiked: false,
                })
              ),
          },
        },
        currentOffset: action.payload.currentOffset || 0,
        currentPage: Math.floor((action.payload.currentOffset || 0) / 36),
        productMinPrice: action.payload.productMinPrice,
        productMaxPrice: action.payload.productMaxPrice,
        currentPriceRange: state.currentPriceRange || [action.payload.productMinPrice, action.payload.productMaxPrice],
        productListitemsResponseError: null,
      };
    case ACTION_TYPE.UPDATE_PRODUCT_LIST_PRICE_RANGE_SUCCESS:
      return {
        ...state,
        productMinPrice: action.payload.productMinPrice,
        productMaxPrice: action.payload.productMaxPrice,
        currentPriceRange: state.currentPriceRange || [action.payload.productMinPrice, action.payload.productMaxPrice], // Use API min/max initially
      };
    case ACTION_TYPE.UPDATE_CURRENT_PRICE_RANGE:
      return {
        ...state,
        currentPriceRange: action.payload,
      };
    case 'RESET_CURRENT_PRICE_RANGE':
      return {
        ...state,
        currentPriceRange: null,
      };
    case ACTION_TYPE.GET_PRODUCT_LIST_DATA_FAILURE:
      return {
        ...state,
        productListitemsResponesLoading: false,
        productListitemsResponseSuccess: [],
        // productMaxPrice: 150000,
        // productMinPrice: 0,
        productListitemsResponseError: action.errorMessage,
      };
    case ACTION_TYPE.GET_PRODUCT_LIST_DATA_LOADING_FALSE:
      return {
        ...state,
        productListitemsResponesLoading: false,
      };
    case ACTION_TYPE.SET_PAGINATION_OFFSET:
      return {
        ...state,
        currentOffset: action.payload.offset,
        currentPage: action.payload.page,
      };
    case ACTION_TYPE.RESET_PAGINATION:
      return {
        ...state,
        currentOffset: 0,
        currentPage: 0,
      };

    default:
      return state;
  }
}

export function getSEODataReducer(state = getSEODataInitialState, action) {
  switch (action.type) {
    case ACTION_TYPE.GET_SEO_DATA_REQUEST:
      return {
        ...state,
        getSEODataResponseLoading: true,
        getSEODataResponseSuccess: [],
        getSEODataResponseError: null,
      };
    case ACTION_TYPE.GET_SEO_DATA_SUCCESS:
      return {
        ...state,
        getSEODataResponseLoading: false,
        getSEODataResponseSuccess: action.payload.getSEODataResponseSuccess,
        getSEODataResponseError: null,
      };
    case ACTION_TYPE.GET_SEO_DATA_FAILURE:
      return {
        ...state,
        getSEODataResponseLoading: false,
        getSEODataResponseSuccess: [],
        getSEODataResponseError: action.errorMessage,
      };

    default:
      return state;
  }
}
